import * as React from 'react'
import {PATHS} from '@frontrow/console/src/entities/helpers/paths'
import {Button} from '@/components/ui/button'

export default function LoginPage(): React.ReactElement {
  const authForward = `${PATHS.unversionedAPIUrl}/auth/page/azureadv2/forward`

  return (
    <div className="absolute h-full w-full bg-[#428bca] flex flex-col justify-center items-center text-center">
      <div className="flex flex-col min-w-[940px] min-h-[600px] py-[100px] px-8 bg-white rounded-lg">
        <h1 className="scroll-m-20 text-4xl font-extrabold tracking-tight lg:text-5xl">
          Freckle Console
        </h1>
        <div className="flex items-center justify-center mt-[60px] mb-[40px]">
          <img
            src={`${PATHS.imageAssetsUrl}/console/login/jt.svg`}
            title="Freckle"
            alt="Freckle Logo"
            className="w-[80px] h-[80px] mr-8"
          />
          <img
            src={`${PATHS.imageAssetsUrl}/console/login/ren.svg`}
            title="Renaissance"
            alt="Renaissance Logo"
            className="w-[80px] h-[80px]"
          />
        </div>
        <p className="leading-7">All Team Members</p>
        <p className="text-sm text-muted-foreground">Use your Renaissance account to log in.</p>
        <Button asChild size="lg" className="w-[200px] h-[62px] mx-auto text-[25px]">
          <a href={authForward} data-test="console-login-button">
            Log In
          </a>
        </Button>
      </div>
    </div>
  )
}
